import React, { useState, useEffect } from "react";
import Sidebar from "../../components/Admin/dashboard/Sidebar";
import DashboardHeader from "../../components/Admin/dashboard/DashboardHeader";
import DashboardContainer from "../../containers/dashboardContainer/DashboardContainer";
import HworkersTable from "../../services/data/HworkersTable"
import axios from "axios";
import axiosInstance from '../../services/axiosconfig/AxiosAuth'

export const delQuery = (asPath) => {
  return asPath.split("?")[0];
};

const AllHealthworkers = () => {
  const [Allorg, setData] = useState({ data: { user: [] } });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const apiUrl = `${process.env.REACT_APP_API_URL}/api/v1/admin/cooperate/get-all-health-worker`;
    axiosInstance
      .get(apiUrl)
      .then((response) => {
        setData(response.data);
        console.log(response.data)
        setLoading(false);
      })
      .catch((error) => {
        console.error("There was a problem with the Axios GET request:", error);
        setLoading(false);
      });
  }, []);

  const [isOpen, setOpen] = useState(false);
  return (
    <div className="flex justify-between bg-[#F9F9F9]  font-Montserrat">
      <Sidebar isOpen={isOpen} setOpen={setOpen} />

      <div className="w-[calc(100%-212px)] xl:w-[calc(100%-212px)] max-[650px]:w-[90%] max-[650px]:pr-[10px]  max-[650px]:pl-[10px]  pl-[33px] pt-[14px] pr-[59px]">
        <DashboardHeader isOpen={isOpen} setOpen={setOpen} />

        <main className=" lg:pt-[25px] min-h-[100vh]  ">
          <div className=" max-[650px]:w-[90%]  max-[650px]:mr-[0px]">
            <HworkersTable />
          </div>
       
        </main>
      </div>
    </div>
  );
};

export default AllHealthworkers;
